import { render, staticRenderFns } from "./DCReviewPurchaseOrder.vue?vue&type=template&id=3fbe1946&"
import script from "./DCReviewPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./DCReviewPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports